<template>
  <div class="video-surveillance">
    <div class="dp-top">
      <div class="left">
        <img class="message-icon" src="../../../assets/home/message-icon.png">
        <div class="message-box" ref="messageBox">
          <div class="scroll-y">
            <AutoScroll :height="101" :step="101" :counts="notice.length" :duation="3000">
              <div v-for="(item, i) in notice" :key="i" class="message" :title="item.id">
                {{ item.area_name + ' ' + item.deviceName }} 发生预警请及时查看
              </div>
            </AutoScroll>
          </div>
        </div>
      </div>
      <div class="right" ref="topRight">
        <div class="btn btn2" @click="showDevice = true"></div>
<!--        <div class="btn btn1"></div>-->
      </div>
    </div>
    <div class="dp-bottom">
      <BottomLeft :type="deviceType" :info="deviceInfo" :token="token" :warning-total="noticeTotal"/>
      <BottomRight @getDeviceInfo="getDevice"/>
    </div>
    <Dialog :show-foot="false" :background-image="require('../../../assets/dp/device-box.png')" width="1600px" v-if="showDevice"
            @close="showDevice = false" @confirm="showDevice = false" title="添加监控摄像头">
      <device></device>
    </Dialog>
  </div>
</template>

<script>
import AutoScroll from "@/components/AutoScroll/index"
import BottomLeft from "./components/BottomLeft";
import BottomRight from "./components/BottomRight";
import Dialog from "@/components/Dialog/index"
import device from "./components/device";
import {getWarningList} from "../../../api/warning";
export default {
  name: "index",
  components: { AutoScroll, BottomLeft, BottomRight, Dialog, device },
  data () {
    return {
      notice: [],
      noticeTotal: 0,
      showDevice: false,
      deviceType: 0,
      deviceInfo: {},
      token: ''
    }
  },
  mounted() {
    this.$bus.on('refreshWarning', () => {
      this.getWarningList()
    })
    this.getWarningList()
  },
  destroyed() {
    this.$bus.off('refreshWarning')
  },
  methods: {
    getWarningList () {
      getWarningList({status: 0,page: 1,limit: 10}).then(res => {
        this.notice = res.data.list
        this.noticeTotal = res.data.totalCount
      })
    },
    getDevice (item) {
      this.deviceType = item.type
      this.deviceInfo = item.info
      this.token = item.token
    }
  }
}
</script>

<style scoped lang="less">
  .video-surveillance{
    height: calc(100vh - 125px);
    padding: 10px 20px;
    .dp-top {
      display: grid;
      grid-template-columns: 1fr 530px;
      align-items: center;

      .left {
        height: 116px;
        display: flex;
        align-items: center;

        .message-icon {
          width: 116px;
          height: 116px;
        }

        .message-box {
          width: calc(100% - 144px);
          height: 101px;
          background-image: url("../../../assets/home/message-box.png");
          background-size: 100% 100%;
          padding-left: 40px;
          padding-right: 60px;
          font-size: 28px;
          font-weight: 400;
          line-height: 101px;
          .message{
            width: 100%;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            cursor: pointer;
            color: #00FFEE;
          }
          .scroll-y{
            height: 101px;
          }
        }
      }

      .right {
        margin-left: 20px;
        height: 101px;
        background-image: url("../../../assets/dp/top-right.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn {
          width: 208px;
          height: 61px;
          background-size: 100% 100%;
          margin: 0 10px;
          cursor: pointer;
        }

        .btn1 {
          background-image: url("../../../assets/dp/sxb-btn.png");
        }

        .btn2 {
          background-image: url("../../../assets/dp/sbe-btn.png");
        }
      }
    }
    .dp-bottom {
      margin-top: 10px;
      height: calc(100% - 126px);
      display: grid;
      grid-template-columns: 1fr 530px;
    }
  }
</style>
